import { CustomHeaderComponent } from '../../components/custom-header/custom-header.component';
import { MAPPER_CONFIGS } from '../../components/mapper-types/model/mappers.model';
import { INTEGRATIONS } from '../global-configuration.constant';
import { GenericMapperDashboardComponent } from '../../generic-mapper-types/generic-mapper-dashboard.component';
import { GenericMapperTypesLoaderService } from '../../service/generic-mapper-types.loader.service';
import { GenericIntegrationSelectComponent } from '../../generic-integration-select/generic-integration-select.component';

const GENERIC_MAPPER_CHILDREN = [
	{
        path: '',
        component: GenericIntegrationSelectComponent,
		data: {
            entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.PROPERTY_TYPES,
            subComponentShow: false,
            breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Generic Integrations'
			}
        }
	},
    {
        path: 'dashboard',
        component: GenericMapperDashboardComponent,
        data: {
            entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.PROPERTY_TYPES,
            subComponentShow: false,
            breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Generic Integrations'
			}
        },
        // canActivate: [GenericMapperTypesLoaderService]
    }
]

export const GENERIC_MAPPER = [
    {
        path: 'generic-integrations',
        pathMatch: 'prefix',
        children: GENERIC_MAPPER_CHILDREN
    }
]
